export const PROVING_MANIFEST_TIMEOUT_MS = 20_000;
export const PROVING_ARTIFACT_TIMEOUT_MS = 120_000;

/** Read public proof inputs only. A download deadline never governs a relay POST. */
export async function readProvingResource<T>(
  fetchImpl: typeof fetch,
  url: string,
  decode: (response: Response) => Promise<T>,
  timeoutMs: number
): Promise<T> {
  const controller = new AbortController();
  let timer: ReturnType<typeof setTimeout> | undefined;
  const expired = new Promise<never>((_, reject) => {
    timer = setTimeout(() => {
      reject(
        new Error(
          "Private transaction files could not be loaded in time. Please try again."
        )
      );
      controller.abort();
    }, timeoutMs);
  });
  try {
    // Includes body consumption; some mobile transports ignore AbortSignal.
    return await Promise.race([
      expired,
      (async () => {
        const response = await fetchImpl(url, {
          method: "GET",
          credentials: "same-origin",
          cache: "no-store",
          signal: controller.signal,
        });
        if (!response.ok) {
          void response.body?.cancel().catch(() => undefined);
          throw new Error(
            `Unable to load private transaction files (${response.status})`
          );
        }
        return decode(response);
      })(),
    ]);
  } finally {
    clearTimeout(timer);
  }
}
